import { noddiAsync, URLKeys } from 'noddi-async';
import { useAuthContext } from 'noddi-web';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';
import { resolveHasBrandDiscounts, resolveHasReferralProgram } from '../utils/hasBrandDiscounts';

export const useHasBrandDiscounts = () => {
  const { currentUserGroupId } = useAuthContext();
  const { currentBrand } = useCurrentBrand();
  const enabled = currentUserGroupId != null;

  const {
    data: coupons,
    isPending: isCouponsPending,
    error: couponsError
  } = noddiAsync.useGet({
    type: URLKeys.getUserGroupCoupons,
    input: {
      userGroupId: currentUserGroupId!,
      brandDomain: currentBrand
    },
    queryConfig: { enabled }
  });

  const {
    data: referral,
    isPending: isReferralPending,
    error: referralError
  } = noddiAsync.useGet({
    type: URLKeys.getReferrals,
    input: { userGroupId: currentUserGroupId!, brandDomain: currentBrand },
    queryConfig: { enabled }
  });

  const isPending = enabled && (isCouponsPending || isReferralPending);
  const hasFetchError = couponsError != null || referralError != null;

  const hasBrandDiscounts =
    enabled && !isPending && !hasFetchError && coupons != null && resolveHasBrandDiscounts(coupons.results.length);

  const hasReferralProgram =
    enabled && !isPending && !hasFetchError && referral != null && resolveHasReferralProgram(referral);

  return { hasBrandDiscounts, hasReferralProgram, isPending };
};
